import { useIsAuthenticated } from '@azure/msal-react'
import { hasOtpToken } from './otp/otpActions'

// Kombinierter Auth-Zustand: ein Nutzer gilt als angemeldet, wenn er entweder
// einen MSAL/Entra-Account hat ODER ein gültiges E-Mail-OTP-Session-Token (V1.14)
// im localStorage liegt. RequireAuth nutzt diesen Hook statt nur MSAL, damit
// OTP-Nutzer nicht zum Entra-Redirect geschickt werden.
export function useIsLoggedIn(): boolean {
  const msalAuthed = useIsAuthenticated()
  return msalAuthed || hasOtpToken()
}
